/**
 * Supabase 클라이언트 (프론트엔드)
 *
 * Vite 환경변수(VITE_ 접두사)에서 Supabase URL과 Anon Key를 읽는다.
 * 환경변수는 Doppler phone-board/dev (로컬) 또는 phone-board/prd (운영)에서 주입.
 */

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // 아래 두 값은 supabase-js 기본값과 동일하다. 동작을 바꾸려는 게 아니라
    // "의도를 코드에 못 박아" 라이브러리 업그레이드로 기본값이 바뀌어도 조용히
    // 깨지지 않게 하려는 것이다.
    persistSession: true, // 세션을 localStorage에 저장 → 새로고침/재방문해도 로그인 유지
    autoRefreshToken: true, // 액세스 토큰 만료 전 자동 갱신 → 갑작스런 로그아웃 방지

    // 아래 옵션들은 일부러 명시하지 않는다(기본값 유지가 안전):
    // - storageKey: 기본 sb-<ref>-auth-token. 바꾸면 기존 로그인 사용자 전원 세션 소실.
    // - storage: 기본 localStorage 유지. supabase-js가 navigator LockManager로
    //   멀티탭 토큰 갱신을 자동 직렬화하는데, storage를 커스텀으로 바꾸면 그 락이
    //   무력화돼 여러 탭이 동시에 토큰을 갱신하다 세션이 깨질 수 있다.
    // - detectSessionInUrl: magic link/OAuth redirect 사용 여부가 불확실 → 기본값 유지.
  },
});
